// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"loading_wrapper__1Gvmx"};